"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFieldValidation = exports.ValidationComponent = void 0;
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const styled_components_1 = __importStar(require("styled-components"));
const main_1 = require("../components/icon/main");
const variants_1 = require("../themes/variants");
function getStatus(touched, error) {
    if (!touched)
        return undefined;
    if (error)
        return "error";
    return "success";
}
function getStatusIcon(status) {
    if (status === "success")
        return "check";
    if (status === "error")
        return "alert";
}
function ValidationComponent(Component) {
    return (0, styled_components_1.default)(Component).withConfig({
        shouldForwardProp: (prop) => !["status"].includes(prop),
    }) `
    ${({ status, theme }) => {
        if (status) {
            const color = `${status === "error"
                ? (0, variants_1.variantTextColor)({ theme, variant: "error" })
                : (0, variants_1.variantTextColor)({ theme, variant: "success" })}!important`;
            return (0, styled_components_1.css) `
          & [data-testid="label"]:after,
          & [data-testid="info"],
          & [data-testid="info"] > i {
            color: ${color};
          }
          & [data-testid="input-container"] {
            border-color: ${color};
            color: ${color};
          }
        `;
        }
    }}
  `;
}
exports.ValidationComponent = ValidationComponent;
function useFieldValidation(props) {
    const { info } = props, others = __rest(props, ["info"]);
    const [field, meta, helpers] = (0, formik_1.useField)(others);
    const status = getStatus(meta.touched, Boolean(meta.error));
    const statusIcon = getStatusIcon(status);
    const infoMessage = info && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(main_1.Icon, { name: statusIcon || "alert-circle" }),
        status === "error" ? meta.error : info));
    return { field, meta, helpers, status, info: infoMessage };
}
exports.useFieldValidation = useFieldValidation;
//# sourceMappingURL=useFieldValidation.js.map